import Component from '@glimmer/component'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import type { TAB_TYPE_KEYS } from 'teacher-ui-client/components/tab-group/tab-types'
import { getTabTypeClasses, getTabThemeClasses } from 'teacher-ui-client/components/tab-group/tab-types'
import { LinkTo } from '@ember/routing'
import { array, hash } from '@ember/helper'

interface Args {
  theme?: ThemeKeys
  tabType?: TAB_TYPE_KEYS
  route?: string
  models?: unknown[]
  query?: NonNullable<unknown>
  currentWhen?: string | boolean
}

interface Signature {
  Args: Args
  Element: Element
  Blocks: {
    default: unknown
  }
}

export class LinkToTabComponent extends Component<Signature> {
  get tabTypeClasses() {
    return getTabTypeClasses(this.args.tabType)
  }

  get tabThemeClasses() {
    return getTabThemeClasses(this.args.tabType, this.args.theme)
  }

  <template>
    {{#if @route}}
      <LinkTo
        data-test-link-to-tab={{@theme}}
        @route={{@route}}
        @models={{if @models @models (array)}}
        @query={{if @query @query (hash)}}
        @activeClass="active"
        @current-when={{@currentWhen}}
        class="{{this.tabTypeClasses}} {{this.tabThemeClasses}}"
        ...attributes
      >
        {{yield}}
      </LinkTo>
    {{else}}
      <LinkTo
        data-test-link-to-tab={{@theme}}
        @models={{if @models @models (array)}}
        @query={{if @query @query (hash)}}
        @activeClass="active"
        @current-when={{@currentWhen}}
        class="{{this.tabTypeClasses}} {{this.tabThemeClasses}}"
        ...attributes
      >
        {{yield}}
      </LinkTo>
    {{/if}}
  </template>
}

export default LinkToTabComponent
